module.exports = __webpack_public_path__ + "static/media/resultats_or2019.4c4bce0b.png";